import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from '@/components/ui/sonner';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { isDonationMode } from '@/config';
import { initGA, logPageView } from '@/utils/analytics';
import HomeDonations from '@/pages/HomeDonations';
import HomeDonationsNew from '@/pages/HomeDonationsNew';
import HomeJoinMovement from '@/pages/HomeJoinMovement';
import About from '@/pages/About';
import OurModel from '@/pages/OurModel';
import ResearchElevated from '@/pages/ResearchElevated';
import Donate from '@/pages/Donate';
import DonationSuccess from '@/pages/DonationSuccess';
import DonationCancel from '@/pages/DonationCancel';
import Contact from '@/pages/Contact';
import JoinTheMovement from '@/pages/JoinTheMovement';
import Evidence from '@/pages/Research';
import EvidenceNew from '@/pages/Research-11-26-25';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsOfService from '@/pages/TermsOfService';
import FoundersCircle from '@/pages/FoundersCircle';
import Pledge from '@/pages/Pledge';
import Volunteer from '@/pages/Volunteer';
import '@/App.css';

// Track page views on route change
function AnalyticsTracker() {
  const location = useLocation();
  
  useEffect(() => {
    logPageView(location.pathname + location.search);
    
    // Handle hash anchor scrolling
    if (location.hash) {
      setTimeout(() => {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location]);
  
  return null;
}

// Home ("/") renders its own design nav + footer, so hide the global chrome there.
function ConditionalChrome({ children }) {
  const location = useLocation();
  const selfChromed = ['/', '/about', '/model', '/research', '/founders-circle', '/partner'];
  return selfChromed.includes(location.pathname) ? null : children;
}

function App() {
  // Initialize Google Analytics on app mount
  useEffect(() => {
    initGA();
  }, []);
  
  // Determine which homepage to show based on config
  const HomePage = isDonationMode() ? HomeDonationsNew : HomeJoinMovement;
  
  // Use new Research variant as default
  const ResearchPage = ResearchElevated;
  
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
        <AnalyticsTracker />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<About />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/donate/success" element={<DonationSuccess />} />
            <Route path="/donate/cancel" element={<DonationCancel />} />
            <Route path="/research" element={<ResearchPage />} />
            <Route path="/research-old" element={<Evidence />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/join-the-movement" element={<JoinTheMovement />} />
            <Route path="/founders-circle" element={<FoundersCircle />} />
            <Route path="/partner" element={<FoundersCircle />} />
            <Route path="/pledge" element={<Pledge />} />
            <Route path="/volunteer" element={<Volunteer />} />
            <Route path="/model" element={<OurModel />} />
            <Route path="/impact" element={<div className="container mx-auto py-12"><h1>Impact - Coming Soon</h1></div>} />
            <Route path="/get-involved" element={<div className="container mx-auto py-12"><h1>Get Involved - Coming Soon</h1></div>} />
            <Route path="/blog" element={<div className="container mx-auto py-12"><h1>Blog - Coming Soon</h1></div>} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <ConditionalChrome><Footer /></ConditionalChrome>
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
